module.exports = __webpack_public_path__ + "img/woman.6ad96fdb.png";